// extracted by mini-css-extract-plugin
export default {"tabsWrapper":"styles_tabsWrapper__CqJpB","tabButton":"styles_tabButton__p1uXi","active":"styles_active__Tp1Xu"};